import { Charts } from './Charts';
import BasicSanitationChartsDataProvider from './contexts/BasicSanitationChartsDataContext';

const BasicSanitationWrapper = () => {
    return (
        <BasicSanitationChartsDataProvider>
            <Charts />
        </BasicSanitationChartsDataProvider>
    );
};

export default BasicSanitationWrapper;
